/**
 * Blocked email domains for signup and password reset.
 * Emails from these domains are rejected client- and server-side.
 */
export const BLOCKED_DOMAINS: string[] = [
  "protonmail.com",
  "yopmail.com",
  "mailinator.com",
  "tutamail.com",
  "tutanota.com",
  "dispostable.com",
]

const BLOCKED_SET = new Set(BLOCKED_DOMAINS.map((d) => d.toLowerCase()))

/**
 * Returns true if the email's domain (or full address) is blacklisted.
 * Normalizes input: trim and lowercase before checking.
 */
export function isEmailBlacklisted(email: string): boolean {
  const normalized = email.trim().toLowerCase()
  if (!normalized) return false
  const at = normalized.indexOf("@")
  if (at === -1) return false
  const domain = normalized.slice(at + 1)
  return BLOCKED_SET.has(domain)
}
